import type { AssetRegisterResponse } from '@risksmart-app/trpc/src/types';
import type {
  Asset_Bool_Exp,
  GetAssetsQuery,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetAssetsDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';

export const mapTrpcAssetsToGraphQL = (
  trpcData: AssetRegisterResponse
): GetAssetsQuery => ({ asset: trpcData.asset });

const useAssetsGraphqlVariables = () => {
  const whereFilter = useEntityWhereFilter<Asset_Bool_Exp>(
    Parent_Type_Enum.Asset
  );

  return { where: whereFilter };
};

type UseGetAssetsRegisterArgs = {
  tagTypeIds?: string[];
  departmentTypeIds?: string[];
};

export const useGetAssetsRegister = createQueryHook<
  UseGetAssetsRegisterArgs,
  AssetRegisterResponse,
  GetAssetsQuery
>({
  trpcQueryOptions: (trpc, args) =>
    trpc.frontend.asset.register.queryOptions({
      tagTypeIds: args.tagTypeIds,
      departmentTypeIds: args.departmentTypeIds,
    }),
  mapTrpcDataToGraphQL: mapTrpcAssetsToGraphQL,
  graphqlDocument: GetAssetsDocument,
  graphqlVariables: useAssetsGraphqlVariables,
});
